import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=62074dde&scoped=true&"
import script from "./Footer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Footer.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=62074dde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62074dde",
  null
  
)

export default component.exports